module.exports = __webpack_public_path__ + "img/Postmodernisme_Kolbein-Falkeid.915160dd.jpg";